import { CreatorPage } from 'components/template/about-us-id';
import { teamData, TeamMember } from 'components/template/about-us/teamData';
import { ParsedUrlQuery } from 'querystring';

export default function AboutUsPageTest({ member }: { member: TeamMember }) {
  return <CreatorPage member={member} />;
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const member = teamData.find(
    (it) => it.name.replace(' ', '-').toLowerCase() === id
  );

  return {
    props: { member },
  };
}
